import { Action, createReducer, on } from "@ngrx/store";
import { clearAccounts, setAccounts, updateDueInfo } from "./account.actions";
import { Account } from "../../core/models/account";

export const featureKey = "accountStore";

export interface State {
  accounts: Account[];
}

const initalState: State = {
  accounts: [],
};

const featureReducer = createReducer(
  initalState,
  on(clearAccounts, (state, action): State => {
    return {
      accounts: [],
    };
  }),
  on(setAccounts, (state, action): State => {
    return {
      accounts: action.accounts,
    };
  }),
  on(updateDueInfo, (state, action): State => {
    const accountIndex = state.accounts.findIndex(
      (x) => x.accountNumber === action.accountNumber
    );

    const account: Account = {
      ...state.accounts[accountIndex],
    };

    account.autoPay = action.autoPay;
    account.balance = action.balance;
    account.dueDate = action.dueDate;
    account.dueDay = action.dueDay;
    account.minimumDue = action.minimumDue;
    account.transactions = action.transactions;

    const accounts = [...state.accounts];

    accounts[accountIndex] = account;

    return {
      accounts,
    };
  })
);

export function reducer(state: State | undefined, action: Action) {
  return featureReducer(state, action);
}
